import './published_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.PostPublishedFilterView extends Monitoring.Views.SocialContents.Filters.PublishedFilterView

  apply: =>
    @searchQuery.setPostFbIsPublished(@getFilterValue())
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
